import React from 'react';
import NavigationBar from '../navigation/NavigationBar';

const AdminLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-background">
      <NavigationBar userType="admin" />
      <main>{children}</main>
    </div>
  );
};

export default AdminLayout;